import template from './wizard_leave_setup_restrictions.html';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupRestrictions
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.priority = ko.observable(1) ;
		this.selected_description = ko.observable();
		this.restriction_rules = ko.observableArray();
		this.leave_restriction_rule_id= ko.observable();
		this.behaviour_rules = ko.observableArray();
		this.leave_type_id = ko.observable(null);
		this.leave_type_linked_restriction_rules = ko.observableArray();

		this.leave_restriction_rule_id.subscribe((newText) => {
			let desc = this.restriction_rules().find(x => x.leave_restriction_rule_id === newText).parsed_description;
			this.selected_description(desc);
		});
	};

	close()
	{
		this.dialog.close();
	}

	async back_wizard()
	{
		if (this.leave_type_id())
		{
			this.dialog.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.leave_type_id()});
			return;
		}

		

		Object.assign(this.dialog.bindings.leave_object, { leave_type_linked_restriction_rules: this.leave_type_linked_restriction_rules() });
		
		this.dialog.close();
		await Grape.dialog.open('WizardLeaveSetupHolidays', this.dialog.bindings);
	};

	next_wizard()
	{
		Object.assign(this.dialog.bindings, { leave_type_linked_restriction_rules: this.leave_type_linked_restriction_rules() });
		let data = this.dialog.bindings;
		Grape.dialog.open('WizardLeaveSetupEmployees', { data: data});
		this.dialog.close();
	};

	remove_linked_rule(v, e)
	{
		let linked_restriction_rules = this.leave_type_linked_restriction_rules();
		let filtered = _.remove(linked_restriction_rules, (n) => {
			return n.leave_type_linked_restrictions_id !== v.leave_type_linked_restrictions_id;
		});
		
		this.leave_type_linked_restriction_rules(filtered);
	}

	add_restriction_rule()
	{
		if (this.priority() <= 0 || this.priority() % 1 != 0)
		{
			Grape.alerts.alert({type: 'error', message: tr('The priority must be a positive integer value'), title: tr('Error')});
			return;
		}

		let restriction_rule = this.restriction_rules().find(x => x.leave_restriction_rule_id === this.leave_restriction_rule_id());
		let customization_field = '';
		let raw_description = '';

		if (restriction_rule)
		{
			customization_field = restriction_rule.customization_fields;
			raw_description = restriction_rule.description;
		}

		let rule = {
			leave_type_linked_restrictions_id : this.dialog.getTemporaryUniqueID(),
			priority : this.priority(),
			behaviour : $('#ddlBehaviour').val(),
			leave_restriction_rule_id: restriction_rule.leave_restriction_rule_id,
			rule_name: restriction_rule.rule_name,
			rule_description: restriction_rule.parsed_description ,
			behaviour_desc: $('#ddlBehaviour option:selected').text(),
			raw_description : restriction_rule.description,
			customization_fields_inherited : customization_field 
		}
		this.leave_type_linked_restriction_rules.push(Object.assign({}, rule));
	}

	async edit_linked_rule(v, e)
	{
		let data = ko.mapping.toJS(v);
		let response = await Grape.dialog.open('LeaveRestrictionRuleLeaveTypeEdit', { data: data });
		this.dialog.update_linked_leave_restriction_customization(response);
	}

	async back_and_save()
	{
		//update fields
		this.dialog.bindings.leave_object.leave_type_linked_restriction_rules = this.leave_type_linked_restriction_rules();
	
		//save new leave type
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.dialog.bindings.leave_object);
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.dialog.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.dialog.bindings.leave_object.leave_type_id});
		}
	}
};

class WizardLeaveSetupRestrictionsPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardLeaveSetupRestrictions(this);
	}

	async init()
	{
		console.log('bindings', this.bindings);
		this.viewModel.restriction_rules(await Grape.cache.get('LeaveRestrictionRules'));
		
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'leave_restriction_behaviour',
			limit: 1000000
		});
		if (res.status !== 'ERROR')
		{
			if (res.records)
				this.viewModel.behaviour_rules(res.records);
		}
	
		if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		//apply bindings
		if (this.bindings.leave_type_linked_restriction_rules)
			this.viewModel.leave_type_linked_restriction_rules(this.bindings.leave_type_linked_restriction_rules);

		if (this.bindings.leave_object.leave_type_linked_restriction_rules)
			this.viewModel.leave_type_linked_restriction_rules(this.bindings.leave_object.leave_type_linked_restriction_rules);
	}

	update_linked_leave_restriction_customization(obj)
	{
		if (obj == null) return;
		let rule = this.viewModel.leave_type_linked_restriction_rules().find(itm => itm.leave_type_linked_restrictions_id === obj.leave_type_linked_restrictions_id);

		if (rule)
		{
			rule.rule_description = obj.rule_description;
			rule.customization_fields_inherited = obj.customization_rules;
		}

		let linked_restrictions = this.viewModel.leave_type_linked_restriction_rules();
		
		let filtered = _.remove(linked_restrictions, (n) => {
			return n.leave_type_linked_restrictions_id !== obj.leave_type_linked_restrictions_id;
		});

		this.viewModel.leave_type_linked_restriction_rules(filtered);
		this.viewModel.leave_type_linked_restriction_rules.push(rule); 
	}

	getTemporaryUniqueID()
	{
		return Math.floor(Math.random() * Date.now());
	}
};

export default {
	name: 'WizardLeaveSetupRestrictions',
	dialog_class: WizardLeaveSetupRestrictionsPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_restrictions',
	provider: 'ps'
};
